import { connect } from 'react-redux';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import { selectors } from 'app-webtech-core';
import { WAM_SLUG } from 'app-modules/base/constants';
import { WAM_D0_ALREADY_DISMISSED as D0_ALREADY_DISMISSED } from 'app-modules/base/feature-discovery';
import * as actions from '../actions';
import { WamDialogManagerComponent } from '../components/WamDialogManager';
import { wamEpisodeStartsOn } from '../utils/wamEpisodeStartsOn';
import { chatEpisodeStartsOn } from '../utils/chatEpisodeStartsOn';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state) => {
  const { content } = selectors.player.properties(state);
  const wamChannel = selectors.linearChannels.fetchBySlug(state)(WAM_SLUG);
  // eslint-disable-next-line no-underscore-dangle
  const isWamChannel = !!wamChannel && !!content && content.id === wamChannel._id;
  const wamEpisodeStartsOnDate = wamEpisodeStartsOn(state);
  const nextWamStartsIn = differenceInMinutes(wamEpisodeStartsOnDate, Date.now());

  const nextChatEpisode = chatEpisodeStartsOn(state);
  let nextChatEpisodeStartsIn = null;
  if (nextChatEpisode) {
    nextChatEpisodeStartsIn = differenceInMinutes(nextChatEpisode.chatStartsOn, Date.now());
  }

  return {
    isWamChannel,
    d0AlreadyDismissed: selectors.application.featureDiscovery(state)(D0_ALREADY_DISMISSED),
    wamEpisodeStartsOnDate,
    nextWamStartsIn,
    nextChatChannelId: nextChatEpisode && nextChatEpisode.channelId,
    nextChatEpisodeStartsIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showOnboardDialog: () => dispatch(actions.showOnboardDialog()),
  showWamNow: () => dispatch(actions.showWamNow()),
  showWamSoon: () => dispatch(actions.showWamSoon()),
  showChatNow: (chId) => dispatch(actions.showChatNow(chId)),
  hideChatNow: () => dispatch(actions.hideChatNow()),
  showChatSoon: (chId) => dispatch(actions.showChatSoon(chId)),
  hideChatSoon: () => dispatch(actions.hideChatSoon()),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  showChatNow: () => {
    const chId = stateProps.nextChatChannelId;
    dispatchProps.hideChatSoon();
    dispatchProps.showChatNow(chId);
  },
  showChatSoon: () => {
    const chId = stateProps.nextChatChannelId;
    dispatchProps.hideChatNow();
    dispatchProps.showChatSoon(chId);
  },
});

export const WamDialogManager = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(WamDialogManagerComponent);
